import * as type from './actionTypes';

export const getCompletionStatusSagas = () => ({
  type: type.GET_COMPLETION_STATUS,
});
